<template>
  <v-container>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-row align="center">
              <v-col cols="3" xl="1">
                <v-checkbox
                  v-model="level.debug"
                  label="Hata Ayıklama"
                  color="primary"
                ></v-checkbox>
              </v-col>
              <v-col cols="3" xl="1">
                <v-checkbox
                  v-model="level.error"
                  label="Hatalar"
                  color="error"
                ></v-checkbox>
              </v-col>
              <v-col cols="3" xl="1">
                <v-checkbox
                  v-model="level.warning"
                  label="Uyarılar"
                  color="warning"
                ></v-checkbox>
              </v-col>
              <v-col cols="3" xl="1">
                <v-checkbox
                  v-model="level.info"
                  label="Bilgi"
                  color="info"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" xl="3">
                <v-select
                  :items="timezones"
                  v-model="selectedTimezone"
                  label="Zaman Damgası"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" xl="4">
                <v-text-field label="Filtre" v-model="filter"></v-text-field>
              </v-col>
              <v-col cols="12" xl="1">
                <v-btn color="primary" @click="reloadLogView">Yenile</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="safeItems"
              :no-data-text="
                $store.state.query.loading
                  ? '...yükleniyor'
                  : $vuetify.noDataText
              "
              hide-default-footer
              :search="filter"
              :items-per-page="itemsPerPage"
            >
              <template #item.level="{ item }">
                <v-chip :color="levelColors[item.level.toLowerCase()]">
                  {{ item.level }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      logView: [],
      parsedLogView: [],
      lastPosition: undefined,
      itemsPerPage: -1,
      filter: "",
      headers: [
        { text: "Zaman", value: "timestamp", sortable: false },
        { text: "Seviye", value: "level", sortable: false },
        { text: "Kanal", value: "channel", sortable: false },
        { text: "Mesaj", value: "msg", sortable: false },
      ],
      level: {
        debug: true,
        error: true,
        warning: true,
        info: true,
      },
      levelColors: {
        debug: "primary",
        error: "error",
        warning: "warning",
        info: "info",
      },
      selectedTimezone: "local",
      timezones: [
        { text: "UTC Saati", value: "utc" },
        { text: "Yerel Saat", value: "local" },
      ],
      scrolledBottom: false,
    };
  },
  computed: {
    safeItems() {
      const v = this.parsedLogView;
      return Array.isArray(v) ? v : [];
    },
  },
  methods: {
    reloadLogView() {},
  },
  // बाकी aynı
};
</script>
